// Stages an enquiry moves through, in order. Used by the status stepper
// on the detail page and to compute the summary counts on the list page.
export const STAGES = [
  "Draft",
  "Published",
  "Quotations Received",
  "Under Evaluation",
  "Quotation Selected",
  "Work Order Initiated",
  "In Development",
  "Completed",
];

const GST_RATE = 0.18;

function priceBreakdown({ material, manufacturing, tooling, other }) {
  const subtotal = material + manufacturing + tooling + other;
  const gst = Math.round(subtotal * GST_RATE);
  return {
    material,
    manufacturing,
    tooling,
    other,
    gst,
    total: subtotal + gst,
  };
}

const quotationsData = [
  {
    id: "APIC-ENQ-00123",
    title: "Smart IoT Water Sensor",
    description: "Battery-powered IoT sensor housing with PCB assembly",
    category: "IoT / PCB",
    industry: "AgriTech",
    qty: 25,
    budgetMin: 100000,
    budgetMax: 200000,
    targetDate: "2026-08-30",
    status: "Quotations Received",
    quotes: [
      {
        id: "q1",
        vendor: "Vizag Precision Works",
        location: "Visakhapatnam",
        verified: true,
        rating: 4.8,
        yearsExp: 12,
        delivery: 18,
        validity: 15,
        payment: "50% Advance · 50% on Dispatch",
        warranty: "6 months on manufacturing defects",
        ...priceBreakdown({ material: 36225, manufacturing: 46575, tooling: 10350, other: 5175 }),
      },
      {
        id: "q2",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 23,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 24150, manufacturing: 31050, tooling: 6900, other: 3450 }),
      },
      {
        id: "q3",
        vendor: "Tirupati Rapid Prototyping",
        location: "Tirupati",
        verified: false,
        rating: 4.5,
        yearsExp: 6,
        delivery: 28,
        validity: 15,
        payment: "50% Advance · 50% on Dispatch",
        warranty: "6 months on manufacturing defects",
        ...priceBreakdown({ material: 33075, manufacturing: 42525, tooling: 9450, other: 4725 }),
      },
      {
        id: "q4",
        vendor: "Kurnool Industrial Fabricators",
        location: "Kurnool",
        verified: true,
        rating: 4.7,
        yearsExp: 10,
        delivery: 33,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 21000, manufacturing: 27000, tooling: 6000, other: 3000 }),
      },
      {
        id: "q5",
        vendor: "Coastal MakerLab",
        location: "Kakinada",
        verified: false,
        rating: 4.3,
        yearsExp: 4,
        delivery: 38,
        validity: 15,
        payment: "50% Advance · 50% on Dispatch",
        warranty: "6 months on manufacturing defects",
        ...priceBreakdown({ material: 29925, manufacturing: 38475, tooling: 8550, other: 4275 }),
      },
    ],
  },
  {
    id: "APIC-ENQ-00118",
    title: "Solar Charge Controller Enclosure",
    description: "CNC-machined aluminium enclosure with vented heat sink",
    category: "CNC / Enclosure",
    industry: "Renewable Energy",
    qty: 50,
    budgetMin: 150000,
    budgetMax: 250000,
    targetDate: "2026-07-15",
    status: "Under Evaluation",
    quotes: [
      {
        id: "q1",
        vendor: "Vizag Precision Works",
        location: "Visakhapatnam",
        verified: true,
        rating: 4.8,
        yearsExp: 12,
        delivery: 20,
        validity: 10,
        payment: "50% Advance · 50% on Dispatch",
        warranty: "6 months on manufacturing defects",
        ...priceBreakdown({ material: 52000, manufacturing: 61000, tooling: 15500, other: 6200 }),
      },
      {
        id: "q2",
        vendor: "Kurnool Industrial Fabricators",
        location: "Kurnool",
        verified: true,
        rating: 4.7,
        yearsExp: 10,
        delivery: 26,
        validity: 10,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 45000, manufacturing: 53000, tooling: 12800, other: 5400 }),
      },
    ],
  },
  {
    id: "APIC-ENQ-00107",
    title: "Modular Cold-Chain Tote",
    description: "Injection-moulded insulated tote with RFID slot",
    category: "Injection Moulding",
    industry: "Logistics",
    qty: 200,
    budgetMin: 300000,
    budgetMax: 450000,
    targetDate: "2026-06-01",
    status: "Work Order Initiated",
    quotes: [
      {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      },
    ],
  },
  {
    id: "APIC-ENQ-00095",
    title: "Wearable Fitness Band Housing",
    description: "TPU-over-molded band housing, IP67 rated",
    category: "Injection Moulding",
    industry: "Wearables",
    qty: 500,
    budgetMin: 200000,
    budgetMax: 350000,
    targetDate: "2026-05-10",
    status: "Draft",
    quotes: [
       {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      }, {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      },
       {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      },
      
    ],
  },
  // ✅ New Draft entries
  {
    id: "APIC-ENQ-00145",
    title: "Drone Propeller Guard Assembly",
    description: "Lightweight carbon-fiber propeller guard for quadcopter drones",
    category: "Aerospace / Drone",
    industry: "Aerospace",
    qty: 100,
    budgetMin: 75000,
    budgetMax: 125000,
    targetDate: "2026-09-15",
    status: "Draft",
    quotes: [
       {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      },
       {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      },

    ],
  },
 
 
 
  {
    id: "APIC-ENQ-00194",
    title: "Robotic Arm End Effector",
    description: "Custom gripper attachment for industrial robotic arm",
    category: "Robotics",
    industry: "Robotics",
    qty: 20,
    budgetMin: 65000,
    budgetMax: 110000,
    targetDate: "2026-08-25",
    status: "Draft",
    quotes: [ {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      },
     {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      },
     {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      },
     {
        id: "q1",
        vendor: "Krishna Advanced Manufacturing",
        location: "Vijayawada",
        verified: true,
        rating: 4.6,
        yearsExp: 8,
        delivery: 35,
        validity: 15,
        payment: "30% Advance · 40% Milestone · 30% on Delivery",
        warranty: "3 months limited warranty",
        ...priceBreakdown({ material: 98000, manufacturing: 112000, tooling: 42000, other: 9000 }),
      },],
  },
];

export default quotationsData;